import { FC, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';

import menuTypes from 'constants/menuTypes';

import Page from 'modules/_shared/components/Pages/Page';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';
import Breadcrumb, {
  BreadcrumbItem,
} from 'modules/_shared/components/Breadcrumb';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';

import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import Button, { ButtonVariants } from 'modules/_shared/components/Buttons';
import { useIncentivesMarket } from '../../contexts/IncentivesMarketContext';

import IncentivesMarketWelcomeBanner from './components/IncentivesMarketWelcomeBanner';
import IncentivesMarketKpiCards from './components/IncentivesMarketKpiCards';
import IncentivesMarketCtaCards from './components/IncentivesMarketCtaCards';
import IncentivesMarketSummaryCards from './components/IncentivesMarketSummaryCards';
import IncentivesMarketRecentActivity from './components/IncentivesMarketRecentActivity';
import IncentivesMarketReferenceInfo from './components/IncentivesMarketReferenceInfo';

import '../../styles/IncentivesMarket.scss';

const WELCOME_BANNER_ENABLED = true;

const IncentivesMarket: FC = () => {
  const { t } = useTranslate();
  const history = useHistory();
  const { data, actions } = useIncentivesMarket();

  const { isAdmin, isBeneficiary } = data;

  useGetMenu(menuTypes.NULL);

  const breadcrumbItems: BreadcrumbItem[] = useMemo(
    () => [
      { label: t('Dashboard'), to: '/' },
      { label: data.societyName, to: `/sociedad/${data.societyId}` },
      { label: t('IncentivesMarket'), isActive: true },
    ],
    [t, data.societyName, data.societyId]
  );

  const pageActions = [
    isAdmin && (
      <Button
        key="equity-admin-panel"
        onClick={() => history.push(`/panel-admin-incentivos/${data.societyId}`)}
      >
        <em className="icon ni ni-shield-check" />
        <span>{t('AdminPanel')}</span>
      </Button>
    ),
    isAdmin && (
      <Button
        key="incentives-market-notifications"
        onClick={() =>
          history.push(`/notificaciones-incentivos/${data.societyId}`)
        }
        variant={ButtonVariants.LIGHT}
      >
        <em className="icon ni ni-bell" />
        <span>{t('Notifications')}</span>
      </Button>
    ),
    isBeneficiary && !isAdmin && (
      <Button key="my-operations" onClick={actions.handleViewMyOperations}>
        <em className="icon ni ni-list-check" />
        <span>{t('MyOperations')}</span>
      </Button>
    ),
    <GoBackButton key="go-back" icon="ni-arrow-left" />,
  ].filter(Boolean);

  return (
    <Page id="incentives-market-page">
      <div className="nk-block-head-content mb-3">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <PageListHeader
        subTitle={t('IncentivesMarket')}
        description={t('IncentivesMarketDescription')}
        actions={pageActions}
      />

      {WELCOME_BANNER_ENABLED && <IncentivesMarketWelcomeBanner />}

      {/* <IncentivesMarketKpiCards /> */}
      <IncentivesMarketCtaCards />
      <IncentivesMarketSummaryCards />
      <IncentivesMarketRecentActivity />
      {/* <IncentivesMarketReferenceInfo /> */}

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default IncentivesMarket;
